import {
  lazyPipe,
  validateApiRequest,
  validateApiResponse,
  withApiErrorCapture,
} from '@musinsa/apis-common-api-zod4';
import { executeStandardRequest } from '@musinsa/packages-http';
import z from 'zod';
import { publicHttpClient } from '../httpClient';
import { createApiResponseSchema } from '../utils';
import { couponsApiPath } from './apiPath';

const GetCouponGoodsCountRequestSchema = z
  .object({
    couponNo: z.number().int(),
    categoryCode: z.string().optional(),
  })
  .describe('GetCouponGoodsCountRequest');

export type GetCouponGoodsCountRequest = z.infer<typeof GetCouponGoodsCountRequestSchema>;

export const GetCouponGoodsCountDataSchema = z
  .object({
    totalCount: z.number().int(),
  })
  .describe('GetCouponGoodsCountData');

export const GetCouponGoodsCountResponseSchema = createApiResponseSchema(
  GetCouponGoodsCountDataSchema,
);
export type GetCouponGoodsCountResponse = z.infer<typeof GetCouponGoodsCountResponseSchema>;

export const fetchCouponGoodsCount = withApiErrorCapture(
  lazyPipe(
    validateApiRequest(GetCouponGoodsCountRequestSchema),
    async ({
      couponNo,
      categoryCode,
    }: GetCouponGoodsCountRequest): Promise<GetCouponGoodsCountResponse> =>
      executeStandardRequest(() =>
        publicHttpClient.get<GetCouponGoodsCountResponse>(
          couponsApiPath.getCouponGoodsCount(couponNo),
          { categoryCode },
        ),
      ),
    validateApiResponse(GetCouponGoodsCountResponseSchema),
  ),
);
